
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pergolas",
      function () {
        return require("private-next-pages/pergolas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pergolas"])
      });
    }
  